
import React, { useMemo } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Input } from "reactstrap";
import { SearchFilter } from "../share/SearchFilter";
import { FaSort } from 'react-icons/fa';


export default function CreateTableHaveFooterComponent (props) {

    const {column, dataInput, FormInput, showEntrie, showPage} = props

    const columns = useMemo(()=>column,[column])
    const data = useMemo(()=> dataInput,[dataInput])

    const { 
        getTableProps, 
        getTableBodyProps, 
        headerGroups,
        footerGroups, 
        page,
        nextPage, 
        previousPage,
        canNextPage,
        canPreviousPage, 
        pageOptions,
        gotoPage,
        pageCount,
        prepareRow,
        setPageSize, 
        state, 
        setGlobalFilter} =  useTable({
        columns: columns,
        data: data
    },
        useGlobalFilter, 
        useSortBy, 
        usePagination
    )

    const {globalFilter, pageIndex, pageSize } = state

    return(
        <>
           
            <div className="d-flex justify-content-between align-items-center">
            {showEntrie ? 
                 <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <span className="mx-2">
                            แสดง {" "}
                        </span>
                        
                        <Input type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                            {
                                [5,10,25,50].map(pageSize =>(
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))
                            }
                        </Input>
                        <span className="mx-2">{" "} รายการ {" "}</span>
                        
                    </div>
                    <SearchFilter search={globalFilter} setSearch={setGlobalFilter}/>
                </div>
                :
                <div style={{visibility:"hidden"}}></div> 
            }
            {FormInput ? 
                <FormInput/>
                :
                <></>
            }
            </div>
                        
            <Table className="styled-table mt-2" striped bordered hover {...getTableProps()}>
                <thead className="text-center">
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} >
                            {
                                headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        <span>
                                            <FaSort/>
                                        </span>
                                    </th>
                                ))
                            }
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {!page.length ? (
                        <tr>
                            <td className="text-center" colSpan={columns.length}>ไม่มีข้อมูล</td>
                        </tr>
                    ):(
                        <>
                            {page.map(row =>{
                                prepareRow(row)
                                return (
                                    <tr className="text-center" {...row.getRowProps()}>
                                        {
                                            row.cells.map((cell) => {
                                                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                        </>
                    )}
                    
                </tbody>
                {page.length ? (
                    <tfoot>
                        {footerGroups.map(group => (
                            <tr {...group.getFooterGroupProps()}>
                                {group.headers.map((column, index) => {
                                    // console.log("column",column)
                                    // console.log("index",index)
                                    return(
                                        <td {...column.getFooterProps()} style={{border:"none", textAlign:"right"}}>{column.render('Footer')}</td>
                                )})}
                                    
                            </tr>
                        ))}
                    </tfoot>
                ):null}
                
            </Table>
            {showPage ? 
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <button className="btn border border-1"  onClick={()=>gotoPage(0)} disabled={!canPreviousPage}>{"หน้าแรก"}</button>
                        <button className="btn border border-1"  onClick={()=>gotoPage(pageCount-1)} disabled={!canNextPage}>{"หน้าสุดท้าย"}</button>
                    </div>
                    
                    <span className="">
                        หน้าที่ {" "}
                        <span className="page-count">
                            {pageIndex + 1} / {pageOptions.length}
                        </span>
                    </span>
                    <div>
                        <button 
                            className="btn border border-1"  
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                            >
                                ก่อนหน้า
                        </button>
                        <button
                            className="btn border border-1" 
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                            >
                                ถัดไป
                        </button>
                    </div>
                </div>
            :
                <></>
            }
            
        </>

                    
            

    )

}